<template>
    <div id="companies-manage" v-if="companies">
        <div class="companies-header">
            <span>BROJ</span>
            <span>IME</span>
            <span>OPIS</span>
            <span>URL</span>
            <span>KATEGORIJA</span>
            <span>L. ŠTANDA</span>
        </div>
        <div class="company" v-for="(company, index) in companies" v-bind:key="company.id">
            <span>{{index+1}}.</span>
            <span>{{company.name}}</span>
            <span>{{company.description}}</span>
            <span>{{company.websiteUrl}}</span>
            <template v-if="company.sponsorCategory">
                <span>{{company.sponsorCategory}}</span>
            </template>
            <template v-else>
                <span>NIJE SPONZOR</span>
            </template>
            <template v-if="company.boothLocation">
                <span>{{company.boothLocation}}</span>
            </template>
            <template v-else>
                <span>NEMA</span>
            </template>
            <button type="button" v-on:click="openAddEditModal(company)">UREDI</button>
            <button type="button" v-on:click="deleteCompany(company)">IZBRIŠI</button>
        </div>
        <button type="button" v-on:click="openAddEditModal()">DODAJ</button>
        <AddEditCompanyModal v-if="modalVisible" v-on:cancel="resetCompany" v-on:save="saveCompany" v-bind:company="companyForModal" v-bind:sponsorCategories="sponsorCategories" />
    </div>
</template>

<script>
    import AddEditCompanyModal from '@/components/admin/companies/AddEditCompanyModal.vue';

    export default {
        name: 'CompanyManage',
        data() {
            return {
                companies: [],
                companyForModal: {},
                modalVisible: false,
                sponsorCategories: []
            }
        },
        components: {
            AddEditCompanyModal
        },
        methods: {
            openAddEditModal: function (company) {
                this.companyForModal = company ? company : {};
                this.modalVisible = true;
            },
            saveCompany: function (companyToSave) {
                if(companyToSave.id)
                    this.$axios.post(`${this.$API_URL}/companies/edit`, companyToSave
                    ).catch(() => {
                        this.$axios.get(`${this.$API_URL}/companies/${companyToSave.id}`).then(response => {
                            this.companies.splice(this.companies.findIndex(company => company.id === companyToSave.id), 1, response.data);
                            alert('Edit tvrtke neuspješan. Nevaljan unos ili zabranjen pristup.');
                        }).catch(() => {
                            alert('Pokušan je edit nepostojeće tvrtke!');
                        });
                    });
                else
                    this.$axios.post(`${this.$API_URL}/companies/add`, companyToSave
                    ).then(response => {
                        companyToSave.id = response.data;
                        this.companies.push(companyToSave);
                    }).catch(() => {
                        alert('Dodavanje tvrtke neuspješno. Dupli unos (ime) ili zabranjen pristup.');
                    });
                this.modalVisible = false;
            },
            resetCompany: function (companyToReset) {
                if(companyToReset.id)
                    this.$axios.get(`${this.$API_URL}/companies/${companyToReset.id}`).then(response => {
                        this.companies.splice(this.companies.findIndex(company => company.id === companyToReset.id), 1, response.data); });
                this.modalVisible = false;
            },
            deleteCompany: function (companyToDelete) {
                if(confirm(`Jeste li sigurni da želite izbrisati tvrtku ${companyToDelete.name}?`))
                    this.$axios.delete(`${this.$API_URL}/companies/delete/${companyToDelete.id}`).then(() => {
                        this.companies.splice(this.companies.findIndex(company => company.id === companyToDelete.id), 1);
                    }).catch(() => {
                        alert("Brisanje neuspješno. Nevaljan unos ili zabranjen pristup.");
                    });
            }
        },
        created() {
            this.$axios.get(`${this.$API_URL}/companies/all-companies`).then(response => {
                this.companies = response.data;
            });

            this.$axios.get(`${this.$API_URL}/companies/sponsor-category-enum`).then(response => {
                this.sponsorCategories = response.data;
            });
        }
    }
</script>

<style scoped>
    .companies-header span,
    .company span {
        word-wrap: break-word;
        display: inline-block;
        height: auto;
        width: 15%;
        margin-right: 5px;
        vertical-align: center;
    }

    span:nth-child(1) {
        width: 5%;
    }

    button {
        padding: 6px;
    }
</style>